export default __webpack_public_path__ + "static/media/Timesheet_line.03a50975.svg";